import type { ReactNode } from 'react';

/**
 * A section-8 section for the lesson detail panes, replacing the pale-blue
 * callout blocks they used.
 *
 * Section 8 has no callout pattern. `db-navy-light` and `#EAF7FD` were doing
 * the job of one, and at 1.15:1 against white they barely read as a surface
 * anyway — the tint signalled "this is special" without actually separating
 * anything.
 *
 * 8.2 is the rule that matters here: the uppercase header sits ABOVE the white
 * section, on the page background, never inside the card.
 */
export default function DetailSection({
  header,
  children,
  className = '',
}: {
  /** Rendered above the section in Footnote 13/18 uppercase. Omit for none. */
  header?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      {header && (
        <div
          className="text-[13px] leading-[18px] font-semibold uppercase text-[rgba(60,60,67,0.6)]"
          style={{ letterSpacing: '0.5px', marginBottom: 16 }}
        >
          {header}
        </div>
      )}
      <div style={{ background: '#FFFFFF', borderRadius: 12, padding: 16 }}>
        {children}
      </div>
    </div>
  );
}
